if (typeof document !== 'undefined' && !document.head.querySelector("style[data-wp-hash='71d20935c2']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "71d20935c2");
	style.appendChild(document.createTextNode("@layer wp-ui-utilities, wp-ui-components, wp-ui-compositions, wp-ui-overrides;@layer wp-ui-components{._19ce0419607e1896__stack{display:flex}}"));
	document.head.appendChild(style);
}
export default {"stack":"_19ce0419607e1896__stack"};
